import { Component } from '@angular/core';

@Component({
  selector: 'app-section-previa-incubadora',
  templateUrl: './section-previa-incubadora.component.html',
  styleUrls: ['./section-previa-incubadora.component.scss'],
})
export class SectionPreviaIncubadoraComponent {}
